<template>
	<div class="row contentblock">
		<div class="columns column6 col-image">
			<picture>
				<source :srcset="imageWebp" type="image/webp" />
				<source :srcset="image" />
				<img :src="image" :alt="imageAlt" loading="lazy" />
			</picture>
		</div>
		<div class="columns column6 col-content">
			<div class="contentblock-content">
				<h3>{{ header }}</h3>
				<div v-parse-links v-html="content" />
			</div>
		</div>
	</div>
</template>

<script setup>
defineProps({
	image: { type: String, default: '' },
	imageWebp: { type: String, default: '' },
	imageAlt: { type: String, default: '' },
	header: { type: String, default: '' },
	content: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.contentblock {
	background-color: var(--secondary-background-color);
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	padding: 0;
	position: relative;

	&:nth-child(even) {
		flex-direction: row-reverse;

		.col-image {
			left: 0;
			right: auto;
		}
	}

	.columns {
		padding: 0;
	}

	img {
		object-fit: cover;
		width: 100%;
		height: 100%;
	}

	.col-content {
		position: relative;
		z-index: 2;
	}

	.col-image {
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		width: 50%;
	}

	.contentblock-content {
		padding: 75px;
		background: var(--brown-light);
	}
}

@media (max-width: 1080px) {
	.contentblock {
		.col-image {
			width: 100%;
			position: relative;
		}

		.contentblock-content {
			padding: 50px;
		}
	}
}

@media (max-width: 580px) {
	.contentblock {
		margin-bottom: 25px;

		.contentblock-content {
			padding: 35px;
		}
	}
}
</style>
